import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  firstName: validationNotEmpty("Firstname"),
  lastName: validationNotEmpty("Lastname"),
  email: validationNotEmpty("Email"),
  phoneNumber: validationNotEmpty("Phone Number"),
  role: validationNotEmpty("Role"),
  status: validationNotEmpty("Status"),
  password: validationNotEmpty("Password"),
  confirmPassword: validationNotEmpty("Confirm Password"),
});